<div data-automation="teams-calling-container-nav" class="navbar pb-3">
  <div class="w-100">
    <ul class="nav nav-tabs justify-content-start">
      <li class="nav-item w-25" role="presentation" (click)="isDelegateManagementSelected = false">
        <span
          data-automation="teams-calling-tab"
          [ngClass]="{ active: !isDelegateManagementSelected, 'text-danger': hasCallingTabError }"
          class="nav-link text-center text-nowrap fs-5"
          id="home-tab"
          role="tab"
        >
          @if (hasCallingTabError) {
            <span
              [class]="ziroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger me-1'"
            ></span>
          }
          {{ 'tkey;microsoft_360.view.teams.number_and_policies.title' | translate }}
        </span>
      </li>
      <li
        class="nav-item w-25"
        role="presentation"
        [ngbTooltip]="delegateManagementDisabledTooltip | translate"
        [disableTooltip]="isDelegateManagementEnabled"
        [container]="'body'"
        (click)="isDelegateManagementEnabled && (isDelegateManagementSelected = true)"
      >
        <span
          [ngClass]="{
            disabled: !isDelegateManagementEnabled,
            active: isDelegateManagementSelected,
            'text-danger': hasForwardingTabError,
          }"
          data-automation="unanswered-call-forwarding-tab"
          class="nav-link text-center text-nowrap fs-5"
          id="profile-tab"
          role="tab"
        >
          @if (hasForwardingTabError) {
            <span
              [class]="ziroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger me-1'"
            ></span>
          }
          {{ 'tkey;microsoft_360.view.teams.call_forward_settings.title' | translate }}
        </span>
      </li>
    </ul>
  </div>
</div>

<div [hidden]="isDelegateManagementSelected">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  @if (!isLoading) {
    <ziro-microsoft-teams-calling-dial-plan-selector-form
      [microsoftDialPlanGroups]="microsoftDialPlanGroups"
      [upn]="upn"
      [teamsLine]="teamsLine"
      [voicePolicies]="voicePolicies"
      [isZpcSyncWarningPresent]="isZpcSyncWarningPresent"
      [isResourceAccount]="isResourceAccount"
      [ms360View]="ms360View"
      [sharedCallingPolicies]="sharedCallingPolicies"
      [tenantId]="tenantId"
    ></ziro-microsoft-teams-calling-dial-plan-selector-form>
  }
</div>

@if (isDelegateManagementEnabled) {
  <div [hidden]="!isDelegateManagementSelected">
    <ziro-unanswered-call-forwarding-settings></ziro-unanswered-call-forwarding-settings>
  </div>
}
